<template>
  <div>
    <b-modal
      v-model="showUpdateDepartment"
      type="warn"
      title="Confirm Update"
      @ok="saveDepartmentFn"
      @cancel="resetData"
      ok-title="Yes, Save"
    >
      <p>Changes made to the department will be reflected in all deliverables it is being used at. Are you sure you want to save the department?</p>
    </b-modal>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(showConfirmModal)">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Title*</label>
              <ValidationProvider mode="passive" rules="required" v-slot="{ errors }">
                <input
                  type="text"
                  v-model="departmentData.title"
                  class="form-control"
                  ref="focusThis"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label>Abbreviation</label>
              <input type="text" v-model="departmentData.abbreviation" class="form-control" />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label>Active: <switches v-model="departmentData.is_active" theme="bootstrap" color="primary"></switches></label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <button
                class="btn btn-primary"
                type="submit"
                data-dismiss="modal"
              >Save</button>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Switches from 'vue-switches';
export default {
  props: ["departmentData"],
  data() {
    const test = this.departmentData;
    return {
      showUpdateDepartment: false,
      enabled: false,
      originalData: test
    };
  },
  components: {
    Switches
  },
  mounted() {
    if(this.departmentData.id == '') {
      this.departmentData.is_active = 1;
    }
  },
  methods: {
    resetData() {
      let self = this;
      if(self.$router.currentRoute.name == 'globalSearch') {
        let currentPageNumber = localStorage.getItem('currentPageNumber');
        let currentGSTab = localStorage.getItem('currentGSTab');
        self.$store.dispatch('globalSearch', {type: currentGSTab, page: currentPageNumber});
      }
    },
    focusMyElement() {
      this.$refs.focusThis.focus();
    },
    showConfirmModal() {
      if(this.departmentData.id == '' || (!this.departmentData.deliverable_count || this.departmentData.deliverable_count == 0)) {
        this.saveDepartmentFn();
      } else {
        this.showUpdateDepartment = true;
      }
    },
    saveDepartmentFn() {
      let self = this;
      this.showUpdateDepartment = false;
      this.$store.dispatch("updateDepartment", this.departmentData).then(function() {
        if(self.$router.currentRoute.name == 'globalSearch') {
          let currentPageNumber = localStorage.getItem('currentPageNumber');
          let currentGSTab = localStorage.getItem('currentGSTab');
          self.$store.dispatch('globalSearch', {type: currentGSTab, page: currentPageNumber});
          self.$store.dispatch('manageUndoActivation', 'Department saved.');
        }
      });
      this.$bvModal.hide("editDepartmentModal");
    },
  },
};
</script>

<style>
</style>